export default __webpack_public_path__ + "static/media/upload_transactions.730c442c.svg";